import $ from 'jquery';
export const init = (selector) => {
  $(selector).on('click', event => {
    event.preventDefault();
    const link = $(event.currentTarget);
    $('html,body').animate({ scrollTop: '0px' }, 300);
    $(link.attr('href')).focus();
  });
};
